import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
/**
 * Creates a stable function callback reference that wont change when inline functions is passed.
 *
 * @param callback Callback to memoize as stable reference
 * @returns stable function reference
 */
export function useStableCallback(callback) {
  const $ = _c(4);
  const callbackRef = useRef(callback);
  let t0;
  let t1;
  if ($[0] !== callback) {
    t0 = () => {
      callbackRef.current = callback;
    };
    t1 = [callback];
    $[0] = callback;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (...t3) => {
      const args = t3;
      return callbackRef.current?.(...args);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const stableCallback = t2;
  return stableCallback;
}